//Reference: EN0119

import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';
export class TerritorialArea extends Mappeable {
    idAreaTerritoriaPk: number;
    txtAreaTerritorial: string;
    mrkActive: boolean;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            txtAreaTerritorial: this.txtAreaTerritorial,
            mrkActive: this.mrkActive
        }
    }


}